import { get, post, put } from "../config/api";
import queryString from "query-string";

export const list = async (props = {}) => {
  let url = `payments`;
  if (Object.keys(props).length) url += `?${queryString.stringify(props)}`;
  return await get(url);
};

export const create = async (props) => await post(`payments`, props);
export const update = async (props) => await put(`payments`, props);

export const details = async (id) => await get(`payments/details?id=${id}`);
export const detailsForUpdate = async (id) => await get(`payments/update?id=${id}`);

export const addPayment = async (props) => await post(`payments/add`, props);
